/**
 * Форматирует дату из ISO (YYYY-MM-DD) в DD.MM.YYYY
 * @param {string} dateString - дата в формате YYYY-MM-DD или объект Date
 * @returns {string} - дата в формате DD.MM.YYYY или '—' если дата отсутствует
 */
export function formatDate(dateString) {
  if (!dateString) return '—';
  // Если это уже строка в формате DD.MM.YYYY, вернуть как есть
  if (/^\d{2}\.\d{2}\.\d{4}$/.test(dateString)) return dateString;
  try {
    // Если передан объект Date или строка с временем
    const date = new Date(dateString);
    if (!isNaN(date.getTime())) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    }
    // Если это строка YYYY-MM-DD
    const parts = dateString.split('-');
    if (parts.length === 3 && parts[0].length === 4) {
      return `${parts[2]}.${parts[1]}.${parts[0]}`;
    }
    return dateString;
  } catch {
    return dateString;
  }
}

/**
 * Преобразует дату из формата DD.MM.YYYY в ISO (YYYY-MM-DD) для input type="date"
 * @param {string} dateString - дата в формате DD.MM.YYYY
 * @returns {string} - дата в формате YYYY-MM-DD
 */
export function toISODate(dateString) {
  if (!dateString) return '';
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) return dateString;
  const parts = dateString.split('.');
  if (parts.length === 3) {
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  }
  return dateString;
}